// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"97":"aboutUs","114":"companyWorth","187":"JoinUs","364":"CustomerStories","443":"about","465":"industryTrends","994":"companyBusiness"}[chunkId] + "." + {"97":"25677ac8","114":"7ebffb02","187":"d0c68e4a","364":"d5bf86ef","443":"3c52e95b","465":"fdabbfe5","994":"8269fe1e"}[chunkId] + ".js";
};